import React, { useCallback, useId } from 'react';
import { FieldWithState } from '../../types/GenericFormTypes';
import {
  FieldLabelProps,
  GenericFieldRow
} from '../../prefabs/GenericFieldRow';
import { GroupFields } from '../../prefabs/GroupFields';

interface FormProps extends FieldLabelProps {
  form?: string;
  gap?: number;
  fields: FieldWithState[];
  handleSubmit?: () => void;
}

export const GenericForm = (props: FormProps) => {
  const {
    fields,
    handleSubmit,
    gap = 16,
    form = useId(),
    ...labelProps
  } = props;

  const renderField = useCallback(
    (f) => {
      return <GenericFieldRow key={f.id + f.type} {...f} {...labelProps} />;
    },
    [labelProps]
  );

  const onSubmit = useCallback(
    (e) => {
      e.preventDefault();
      handleSubmit?.();
    },
    [handleSubmit]
  );
  return (
    <form onSubmit={onSubmit} id={form}>
      <GroupFields fields={fields} gap={gap} renderField={renderField} />
    </form>
  );
};
